import Typography from "@mui/material/Typography";
import { Children } from "react";
import { cn } from "@/lib/utils";

interface FieldLabelProps {
  children: React.ReactNode;
  htmlFor?: string;
  className?: string;
}

export function FieldLabel({ children, htmlFor, className }: FieldLabelProps) {
  const content = Children.map(children, (child) => {
    if (typeof child !== "string" || !/\s\*$/.test(child)) return child;
    return (
      <>
        {child.replace(/\s\*$/, "")}
        <span className="form-required">*</span>
      </>
    );
  });
  return (
    <Typography
      component="label"
      htmlFor={htmlFor}
      id={htmlFor ? `${htmlFor}-label` : undefined}
      variant="body2"
      sx={{
        fontWeight: 500,
        display: "block",
        fontSize: "0.8125rem",
        lineHeight: 1.4,
        color: "var(--foreground)",
      }}
      className={cn("form-label", className)}
    >
      {content}
    </Typography>
  );
}
